import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './store';
import { ToastProvider } from './context/ToastContext';
import { NotificationProvider } from './context/NotificationContext';
import axios from 'axios';
import './services/timeoutInterceptor';
import { installTenantHeaderInterceptor } from './services/tenantHeaders';
import reportWebVitals from './reportWebVitals';

// Covers every file that does `import axios from 'axios'` directly instead
// of the shared `api` instance in services/api.js (most of this codebase) —
// same reasoning as installTimeoutInterceptor above.
installTenantHeaderInterceptor(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </ToastProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registering a service worker (even a no-op one) is required for Chrome/Edge
// to treat the app as installable — see usePwaInstall.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
